import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '../../features/dashboard/DashboardPage.jsx';

export const Route = createFileRoute('/_app/dashboard')({ component: DashboardPage });
